import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {LogService} from "../../../services/log.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UserData} from "../../../auth.service";

@Component({
    selector: 'app-log-verify-dialog',
    templateUrl: './log-verify-dialog.component.html',
    styleUrls: ['./log-verify-dialog.component.scss']
})

export class LogVerifyDialogComponent implements OnInit {
    reviewedBy: string=''
    remark = ''
    // @ts-ignore
    ref: any
    status: string
    id: string
    @Inject(MAT_DIALOG_DATA) public data: any;

    constructor(private readonly mLogService: LogService,
                private readonly mDialogRef: MatDialogRef<LogVerifyDialogComponent>,
                @Inject(MAT_DIALOG_DATA) data: any,
                private readonly mSnackbar: MatSnackBar,
    ) {
        this.status = data.status;
        this.id = data.id
        this.ref = data.ref
        this.remark = data.reviewRemark
// alert(`${this.status} ${this.ref  }` )
     const user = JSON.parse(localStorage.getItem('userData')!!)
      // console.log(user.userName)
      this.reviewedBy = user.userName!!
    }

    ngOnInit(): void {
    }

    onSubmit() {
        this.mLogService.updateSessionLog(this.ref, this.status, this.remark,this.reviewedBy).then(res => {
            this.mSnackbar.open('Updated Successfully', '', {
                panelClass: 'success',
                duration: 3000
            })
          let activity = {
            date: new Date().getTime(),
            section: 'Individual Education',
            action: 'Update',
            description: `Individual Session for Update to Education by user`,
            currentIp: localStorage.getItem('currentip')!
          }
          this.mLogService.addLog(activity)
        })
        this.mDialogRef.close({
            status: this.status,
            reviewRemark: this.remark,
            id: this.id,

        })
    }

}
